<!-- <div class="rounded-xl border border-card-contrast bg-card p-4">
  <div class="flex items-center justify-between pb-3">
    <div>
      <div class="text-sm text-foreground-secondary">Your transaction records</div>
      <div class="font-medium text-foreground">Payment History</div>
    </div>
    <i class="pi pi-filter text-foreground-tertiary"></i>
  </div>

  <app-table
    [columns]="columns"
    [getDataFunc]="getPaymentData"
    [paginationPageSize]="5"
    [showExportToExcel]="false"
  />
</div> -->
<!--
<div class="p-5 bg-gray-100 dark:bg-[#1B3C53] rounded-xl ">

            <h1 class="text-xl font-semibold mb-6">Payment History</h1>
<div
  class="rounded-2xl bg-white dark:bg-gray-800 p-4 mt-4 w-full shadow-[0_2px_4px_rgba(0,0,0,0.04),0_8px_24px_rgba(0,0,0,0.06)]"
>
  <p-table [value]="payments" stripedRows [tableStyle]="{ width: '100%' }" class="w-full">
     Header
    <ng-template pTemplate="header">
      <tr class="bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
        <th class="px-4 py-3 font-semibold">Date</th>
        <th class="px-4 py-3 font-semibold">Description</th>
        <th class="px-4 py-3 font-semibold">Amount</th>
        <th class="px-4 py-3 font-semibold">Status</th>
      </tr>
    </ng-template>

    < Body     <ng-template pTemplate="body" let-payment>
      <tr
        class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition"
      >
        <td class="px-4 py-3 text-gray-700 dark:text-gray-200">
          {{ payment.date }}
        </td>
        <td class="px-4 py-3 text-gray-700 dark:text-gray-200">
          {{ payment.description }}
        </td>
        <td class="px-4 py-3 text-gray-700 dark:text-gray-200">
          {{ payment.amount | currency: 'INR' }}
        </td>

        <td class="px-4 py-3">
          <p-tag
            [value]="payment.status"
            [severity]="getSeverity(payment.status)"
            class="text-xs"
          ></p-tag>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</div> -->

<div class=" bg-card mt-4 rounded-2xl shadow-lg">



  <!-- Page / Table Header -->
  <div class="mb-6 p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
    <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-100">Payment History</h1>
  </div>

  <!-- Table Card -->
  <!-- <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md p-4 overflow-x-auto"> -->
  <app-table
    [columns]="columns"
    [getDataFunc]="getPayments"
    [paginationPageSize]="10"
    class="rounded-xl"
  >
  </app-table>
</div>
<!-- </div> -->
